import { FieldState } from 'formstate'
import React from 'react'
import { Trans } from '@lingui/macro'
import { observer } from 'mobx-react-lite'
import PasswordCheckInput from '../../ui-kit/forms/input/password-check-input'

export const WidgetNewPassword: React.FC<{ field: FieldState<string> }> = observer(({ field }) => {
  return (
    <div style={{ paddingBottom: 15 }}>
      <div className="text-color-grey-600 mb-large mt-large">
        <Trans>Zadajte, prosím, vaše nové heslo.</Trans>
      </div>

      <PasswordCheckInput
        id="new-password"
        passwordField={field}
        label={<Trans>Nové heslo</Trans>}
      />

      {/* <ButtonLayout direction={{ m: 'horizontal' }} className="align-items-right">
        <ButtonPrimary
          size="large"
          submit
          isDisabled={sending || form.form.hasError}
          data-testid="btn-submit">
          <Trans>Zmeniť heslo</Trans>
        </ButtonPrimary>
      </ButtonLayout> */}
    </div>
  )
})

WidgetNewPassword.displayName = 'WidgetNewPassword'
